import { render, staticRenderFns } from "./EMRDashboardSkletonLoader.vue?vue&type=template&id=529e55d4&scoped=true"
import script from "./EMRDashboardSkletonLoader.vue?vue&type=script&lang=js"
export * from "./EMRDashboardSkletonLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529e55d4",
  null
  
)

export default component.exports